<script>
import TitleWithRow from '@/components(new)/UI/Typography/TitleWithRow/TitleWithRow.vue'
import Label from '@/components(new)/UI/Forms/Label/Label.vue'
import InputSelect from '@/components(new)/UI/Forms/InputSelect/InputSelect.vue'
import { opcoesFonteFinanciamento } from '@/libs/constants/praticas/opcoesSelects'

export default {
  props: {
    pratica: {
      required: true
    },
    nomeAba: {
      type: String,
      required: true
    },
    // validação dos campos para as práticas SPDG e SPDH
    praticasArray: {
      typeof: Array,
      require: false,
      default: null
    }
  },
  components: {
    TitleWithRow,
    Label,
    InputSelect
  },
  data () {
    return {
      opcoesFonteFinanciamento
    }
  },
  computed: {
    rules () {
      return !this.praticasArray ? 'required' : !this.praticasArray.length ? 'required' : ''
    }
  },
  methods: {
    containsOption (value, option, model) {
      let contains
      if (!Array.isArray(value)) {
        contains = value === option
      } else {
        contains = value.includes(option)
      }
      if (!contains) {
        const props = model.split('.')
        const lastProp = props.pop()
        const target = props.reduce((acc, curr) => acc?.[curr], this.pratica)
        if (target && lastProp) {
          target[lastProp] = null
        }
      }
      return contains
    }
  }
}
</script>

<template>
  <div>
    <TitleWithRow title="Financiamento" />
    <el-row :gutter="20">
      <InputSelect
        label="Fonte de financiamento para implementação da prática"
        v-model="pratica.financiamentos"
        :nomeAba="nomeAba"
        :obrigatorio="true"
        :rulesInput="rules"
        :opcoes="opcoesFonteFinanciamento"
        :widthColumn="12"
        :multiSelect="true"
      />
      <validation-provider
        :rules="rules" v-slot="{ errors }" mode="lazy" :name="nomeAba + '/Qual?'"
        v-if="containsOption(pratica.financiamentos, 'OUTRO', 'outroFinanciamento')"
      >
        <el-col :span="8">
          <Label label="Qual?" :obrigatorio="true" />
          <el-input name="Qual?" v-model="pratica.outroFinanciamento" :class="{'input erro' : errors.length}" />
          <span class="help erro"> {{ errors[0] }}</span>
        </el-col>
      </validation-provider>
    </el-row>
  </div>
</template>



// WEBPACK FOOTER //
// src/components(new)/UI/Forms/FormulariosProntos/Financiamentos/Financiamentos.vue